import { TourDetailData } from '@/hooks/useTourDetail';

export interface FlatTourData {
  id: string;
  title: string;
  description?: string;
  cover_image?: string;
  duration?: number;
  tour_type?: string;
  status: string;
  tags?: string[];
  exhibits?: string[];
  exhibitCount?: number;
  displayOrder?: number | null;
  // Add map fields - FIXED
  mapType?: string;
  mapImage?: string | null;
}

export function transformTourData(tour: any, language: string): FlatTourData {
  const translations = tour.tour_translations || [];
  const currentTranslation = translations.find((t: any) => t.language_code === language);
  const englishTranslation = translations.find((t: any) => t.language_code === 'en');
  const fallbackTranslation = translations[0];

  const activeTranslation = currentTranslation || englishTranslation || fallbackTranslation;

  return {
    id: tour.id,
    title: activeTranslation?.title || tour.name || 'Untitled Tour',
    description: activeTranslation?.description || '',
    cover_image: tour.cover_image || '',
    duration: tour.duration || 0,
    tour_type: tour.tour_type || 'indoor',
    status: tour.status || 'draft',
    tags: tour.tags || [],
    exhibits: tour.exhibits || [],
    exhibitCount: tour.exhibits?.length || 0,
    displayOrder: tour.display_order || null,
    mapType: tour.maptype || 'indoor',
    mapImage: tour.mapimage || null
  };
}
